"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.OpenAPIContentIndex = void 0;
var json_pointer_1 = require("@criteria/json-pointer");
var json_schema_1 = require("@criteria/json-schema");
var visitOpenAPIObjects_1 = require("../specification/v3.1/visitOpenAPIObjects");
var uri_1 = require("../util/uri");
var OpenAPIContentIndex = /** @class */ (function () {
    function OpenAPIContentIndex() {
        // Indexes OpenAPI objects and { $ref }
        this.openAPIObjectsByURI = new Map();
        this.infosByOpenAPIObject = new Map();
        this.schemaContentIndex = new json_schema_1.SchemaContentIndex();
    }
    OpenAPIContentIndex.prototype.isObjectIndexed = function (object) {
        if (this.schemaContentIndex.isObjectIndexed(object)) {
            return true;
        }
        return this.infosByOpenAPIObject.has(object);
    };
    OpenAPIContentIndex.prototype.isURIIndexed = function (uri) {
        if (this.schemaContentIndex.isURIIndexed(uri)) {
            return true;
        }
        return this.openAPIObjectsByURI.has(uri);
    };
    OpenAPIContentIndex.prototype.indexedObjectWithURI = function (uri) {
        if (this.schemaContentIndex.isURIIndexed(uri)) {
            return this.schemaContentIndex.indexedObjectWithURI(uri);
        }
        return this.openAPIObjectsByURI.get(uri);
    };
    OpenAPIContentIndex.prototype.infoForIndexedObject = function (object) {
        if (this.schemaContentIndex.isObjectIndexed(object)) {
            var info = this.schemaContentIndex.infoForIndexedObject(object);
            return {
                baseURI: info.baseURI,
                metadata: {
                    type: 'schema',
                    openAPIVersion: '',
                    metaSchemaURI: info.metadata.metaSchemaURI
                }
            };
        }
        return this.infosByOpenAPIObject.get(object);
    };
    OpenAPIContentIndex.prototype.addContentFromRoot = function (root, baseURI, rootMetadata) {
        var _this = this;
        var foundReferences = new Map();
        // TODO: switch on version
        // const visitOpenAPIObjects = (metaSchemaURI: string) => {
        //   switch (metaSchemaURI) {
        //     case 'https://json-schema.org/draft/2020-12/schema':
        //       return visitSubschemasDraft2020_12
        //     case 'http://json-schema.org/draft-04/schema#':
        //       return visitSubschemasDraft04
        //     default:
        //       return visitOpenAPIObjects(rootMetadata.openAPIVersion)
        //   }
        // }
        (0, visitOpenAPIObjects_1.visitOpenAPIObjects)(root, rootMetadata.type, {
            baseURI: baseURI,
            metadata: {
                openAPIVersion: rootMetadata.openAPIVersion,
                metaSchemaURI: rootMetadata.metaSchemaURI
            }
        }, function (type, object, path, state) {
            if (typeof object !== 'object') {
                return;
            }
            if (_this.infosByOpenAPIObject.has(object)) {
                return;
            }
            var baseURI = state.baseURI, _a = state.metadata, openAPIVersion = _a.openAPIVersion, metaSchemaURI = _a.metaSchemaURI;
            if (type === 'schema') {
                var schemaReferences = _this.schemaContentIndex.addContentFromRoot(object, baseURI, {
                    metaSchemaURI: metaSchemaURI
                });
                var location = path.join('');
                var i = location.lastIndexOf('/');
                var parent_1 = location === '' ? null : (0, json_pointer_1.evaluateJSONPointer)(location.slice(0, i), root);
                var key_1 = (0, json_pointer_1.unescapeReferenceToken)(location.slice(i + 1));
                schemaReferences.forEach(function (info, reference) {
                    foundReferences.set(reference, {
                        resolvedURI: info.resolvedURI,
                        parent: info.parent === null ? parent_1 : info.parent,
                        key: info.parent === null ? key_1 : info.key,
                        metadata: {
                            type: 'schema',
                            openAPIVersion: rootMetadata.openAPIVersion,
                            metaSchemaURI: info.metadata.metaSchemaURI
                        },
                        isDynamic: info.isDynamic,
                        path: __spreadArray(__spreadArray([], __read(path), false), __read(info.path), false)
                    });
                });
            }
            else {
                _this.infosByOpenAPIObject.set(object, {
                    baseURI: baseURI,
                    metadata: {
                        type: type,
                        openAPIVersion: openAPIVersion,
                        metaSchemaURI: metaSchemaURI
                    }
                });
                if ('$ref' in object && typeof object.$ref === 'string') {
                    var $ref = (0, uri_1.resolveURIReference)(object.$ref, state.baseURI);
                    var location = path.join('');
                    var i = location.lastIndexOf('/');
                    var parent = location === '' ? null : (0, json_pointer_1.evaluateJSONPointer)(location.slice(0, i), root);
                    var key = (0, json_pointer_1.unescapeReferenceToken)(location.slice(i + 1));
                    // Don't retrieve yet, because it may resolve to a nested schema with an id
                    foundReferences.set(object, {
                        resolvedURI: $ref,
                        parent: parent,
                        key: key,
                        metadata: {
                            type: type,
                            openAPIVersion: openAPIVersion,
                            metaSchemaURI: metaSchemaURI
                        },
                        isDynamic: false,
                        path: path
                    });
                }
            }
        });
        return foundReferences;
    };
    return OpenAPIContentIndex;
}());
exports.OpenAPIContentIndex = OpenAPIContentIndex;
